var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-menu"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 20,
  y1: 12,
  y2: 12
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 20,
  y1: 6,
  y2: 6
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 20,
  y1: 18,
  y2: 18
})));
export { SvgMenu as ReactComponent };
export default __webpack_public_path__ + "0b08a7f42ecc6214278554ab96831fc4.svg";